import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppUser, Snackbar } from '@models/models';
import { EditProfileComponent } from '@components/pages/edit-profile/edit-profile.component';
import { CredentialsApiService } from '@services/api-calls/credentials-api.service';
import { MeetingsManagementComponent } from '@components/shared/meetings-management/meetings-management.component';
import { NotificationsComponent } from '@components/shared/notifications/notifications.component';
import { SnackbarService } from '@services/snackbar.service';
import { ServerDocsService } from '@services/server-docs.service';
import { HelpersService } from '@providers/helpers/helpers';
import { StoreUser } from '@providers/store/user.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    public menu_open: boolean = false;
    public user: AppUser = null;
    public userAvatar: string | ArrayBuffer;
    public fakeAvatar: any = 'assets/images/fake-avatar.svg';
    public snackbar: Snackbar;
    public limited_partner: boolean = false;
    public hasNotifications: boolean = true;

    @ViewChild(EditProfileComponent, { static: true })
    editProfile: EditProfileComponent;
    @ViewChild(MeetingsManagementComponent, { static: true })
    meetingsManagement: MeetingsManagementComponent;
    @ViewChild(NotificationsComponent, { static: true })
    notifications: NotificationsComponent;

    constructor(
        public router: Router,
        private credentialsApiService: CredentialsApiService,
        private snackbarService: SnackbarService,
        private docService: ServerDocsService,
        private helper: HelpersService,
        private userStore: StoreUser
    ) {}

    ngOnInit() {
        this.getUserAvatar();
        this.snackbar = new Snackbar();
        this.snackbarService.setSnackbar(this.snackbar);
    }

    /**
     * Loads user avatar on topbar
     */
    getUserAvatar(): void {
        this.credentialsApiService.getUser().subscribe((user) => {
            if (user['avatar']) {
                this.docService.getImage(user['avatar']).subscribe(
                    async (response) => {
                        this.userAvatar = await this.helper.createImageFromBlob(
                            response
                        );
                        this.userStore.setAvatar(
                            await this.helper.createImageFromBlob(response)
                        );
                    },
                    (error) => {
                        console.log(error);
                        this.userAvatar = 'assets/images/fake-avatar.svg';
                    }
                );
            }
        });
    }

    // used to update avatar in topbar
    updatedUser(event: boolean): void {
        if (event) {
            this.getUserAvatar();
        }
    }

    logout(): void {
        this.credentialsApiService.logout();
    }
}
